import { z } from 'zod';
import { Translation } from './translation';

export const FindPlatformRoleDto = z
  .object({
    id: z.string().uuid().optional(),
    name: z
      .string()
      .min(3, 'VALIDATION__Min3CharLimit')
      .max(255, 'VALIDATION__Max255CharLimit')
      .optional(),
  })
  .strict();

export type ApiFindPlatformRoleDto = z.infer<typeof FindPlatformRoleDto>;

export const UpdatePlatformRoleDto = z
  .object({
    permissionKeys: z.array(z.string()).optional(),
    users: z.array(z.string()).optional(),
    translations: z.array(Translation),
  })
  .strict();

export type ApiUpdatePlatformRoleDto = z.infer<typeof UpdatePlatformRoleDto>;

/**
 * NOTE — the name is historical and now misleading: since platform-user-class
 * F0 the only creator of roles is the ORGANIZATION route
 * (`POST /v2/organizations/:organizationId/roles`). `POST /v2/roles` is gone
 * and custom platform roles no longer exist — the `platform_` key prefix is
 * reserved and `RoleService.create` rejects it. Read "Platform" here as
 * "system-shaped role payload", not as the platform user class.
 */
export const CreatePlatformRoleDto = z.object({
  permissionKeys: z.array(z.string()),
  users: z.array(z.string()).optional(),
  translations: z.array(Translation),
});

export type ApiCreatePlatformRoleDto = z.infer<typeof CreatePlatformRoleDto>;

/**
 * FE ONLY
 */
export const RoleDto = z.object({
  id: z.string(),
  key: z
    .string()
    .min(3, 'VALIDATION__Min3CharLimit')
    .max(255, 'VALIDATION__Max255CharLimit'),
  organizationId: z.string().uuid(),
  permissionKeys: z.array(z.string()),
  translations: z.array(Translation),
});

export type ApiRoleDto = z.infer<typeof RoleDto>;
